import { tv } from '~/utils/tv'

export const InputMultiSelectQuantityContainerVariants = tv({
  base: 'flex w-full flex-wrap gap-1',
})

export const InputMultiSelectQuantityItemVariants = tv({
  base: 'flex h-[2rem] max-h-[2.5rem] items-center justify-center gap-onepulse rounded-[999px] border border-[#9E9E9E] px-twopulse py-onepulse font-bold text-[#575757] text-sm',
})

export const InputMultiSelectQuantityButtonVariants = tv({
  base: 'flex rotate-45',
})
